import { useAppSelector } from '../reducers';
import { getFirstHubSkuIdFromProductConfigurations } from '../selectors/ProductConfigsSelectors';
import { productForSkuIdSelector } from '../selectors/ProductsSelectors';

/**
 * Custom hook to get apiName from product configurations.
 * First tries to get apiName from the first hub product in the configurations.
 * If no hub product is found (e.g., for seat purchases), falls back to getting
 * apiName from the first product configuration's SKU.
 *
 * @param productConfigurations - Array of product configurations to extract apiName from
 * @returns The best apiName for the given product configurations, or undefined if none found
 *
 * @example
 * // For a hub product (e.g., Marketing Hub Professional)
 * const apiName = useBestApiNameFromProductConfigurations(productConfigurations);
 * // Returns: "marketing-hub-professional"
 *
 * @example
 * // For seats purchase
 * const apiName = useBestApiNameFromProductConfigurations(productConfigurations);
 * // Returns: "core-seats-professional"
 */
export const useBestApiNameFromProductConfigurations = productConfigurations => {
  const firstHubSkuId = useAppSelector(state => getFirstHubSkuIdFromProductConfigurations(state, {
    productConfigurations
  }));
  const apiName = useAppSelector(state => {
    var _productForSkuIdSelec;
    return firstHubSkuId ? (_productForSkuIdSelec = productForSkuIdSelector(state, {
      skuId: firstHubSkuId
    })) === null || _productForSkuIdSelec === void 0 ? void 0 : _productForSkuIdSelec.apiName : undefined;
  });

  // For seats and other non-hub products, get the API name from the first SKU itself
  const fallbackApiName = useAppSelector(state => {
    var _productForSkuIdSelec2;
    return productConfigurations.length > 0 ? (_productForSkuIdSelec2 = productForSkuIdSelector(state, {
      skuId: productConfigurations[0].skuId
    })) === null || _productForSkuIdSelec2 === void 0 ? void 0 : _productForSkuIdSelec2.apiName : undefined;
  });
  return apiName || fallbackApiName;
};